interface Record {
  id?: number
  slug?: string
  token?: string
  kind?: string
}

interface PathGetters {
  [key: string]: (record: Record) => string
}

const getters: PathGetters = {
  Project: ({ slug }) => `/projects/${slug}`,
  Invitation: ({ token }) => `/invitations/${token}`,
  Folder: ({ slug, kind }) =>
    kind === 'document'
      ? `/documents/folder/${slug}`
      : `/projects/folder/${slug}`,
  Document: ({ id }) => `/documents/${id}`,
  Filing: ({ id }) => `/tools/bankruptcy-screener/${id}`,
}

export const getInvitationPath = (record: Record) => getters.Invitation(record)
export const getProjectPath = (record: Record) => getters.Project(record)
export const getFolderPath = (record: Record) => getters.Folder(record)
export const getDocumentPath = (record: Record) => getters.Document(record)
export const getFilingPath = (record: Record) => getters.Filing(record)
